import { Title } from '@angular/platform-browser';
import { Component, OnInit, Input, Output, EventEmitter, DestroyRef } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import { MatDialog } from '@angular/material/dialog';

import { AuthenticationService, CredentialsService } from '@app/core';
import { ProfileFormComponent } from '@app/profile-feature/components';
import { IndividualsDestructionFormComponent } from '@app/individuals-destruction/components';
import { DamagedProjectsFormComponent } from '@app/damaged-projects/components';
import { CommercialDamagedFormComponent } from '@app/commercial-damaged/components';
import { GovernmentalDamagedFormComponent } from '@app/governmental-damaged/components';
import { PermissionsService } from '@app/core/permissions/permissions.service';
import { SortingPlantFormComponent } from '@app/sorting-plant/components';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LanguageOption, LanguageService } from '@app/core/language/language.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() sidenav!: MatSidenav;
  @Input() menuSizeState: string;
  @Output() menuSizeStateEvent = new EventEmitter<boolean>();
  userName: string;
  constructor(
    private router: Router,
    private titleService: Title,
    private authenticationService: AuthenticationService,
    private credentialsService: CredentialsService,
    public dialog: MatDialog,
    public permissionsService: PermissionsService,
    private languageService: LanguageService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit() {
    this.userName = this.username;
  }

  setLanguage(lang: { value: string; label: string; flag: string }) {
    this.languageService.setLanguage(lang.value);
  }

  get isEnglish(): boolean {
    return this.languageService.isEnglish;
  }
  get languages() {
    return this.languageService.languages;
  }

  get selectedLanguage(): LanguageOption {
    return this.languageService.selectedLanguage;
  }

  logout() {
    this.authenticationService
      .logout()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.router.navigate(['/login'], { replaceUrl: true }));
    this.credentialsService.setCredentials();
  }

  get username(): string | null {
    const credentials = this.credentialsService.credentials;
    return credentials ? credentials.username : null;
  }

  get title(): string {
    return this.titleService.getTitle();
  }

  get currentLang(): string {
    return this.languageService.currentLang;
  }

  sidenavToggle() {
    this.menuSizeStateEvent.emit(true);
  }

  openProfile(name: string) {
    if (name === 'profile') {
      this.openDialog(ProfileFormComponent);
    }

    switch (name) {
      case 'Individuals-destruction':
        this.openDialog(IndividualsDestructionFormComponent);
        break;
      case 'damaged-projects':
        this.openDialog(DamagedProjectsFormComponent);
        break;
      case 'commercial-damaged':
        this.openDialog(CommercialDamagedFormComponent);
        break;
      case 'governmental-damaged':
        this.openDialog(GovernmentalDamagedFormComponent);
        break;
      case 'sorting-plant':
        this.openDialog(SortingPlantFormComponent);
        break;
      default:
      // code block
    }
  }

  openDialog(component: any, data?: any): void {
    const dialogRef = this.dialog.open(component, {
      width: '60%',
      panelClass: 'scrollableDialog',
      data: data ? data : {},
      disableClose: true // disable close modal if click outside modal
    });
    // dialogRef.afterClosed().subscribe(result => {
    //   this.router.navigate(['../'], { relativeTo: this.route });
    // });
  }

  checkPermission(key?: string) {
    // console.log(!!this.permissionsService.getPermissions(key));
    return !!this.permissionsService.getPermissions(key);
  }
}
